module.exports = __webpack_public_path__ + "img/124.2.1daec515.png";